import type { Language } from '@seek/forms-ui/lib/types';

import { Experience } from '../types';

const additionalLanguages = ['th', 'id'];

export const getLanguageSuffix = (
  language: Language,
  locale: string,
  experience?: Experience,
  path?: string,
): string => {
  switch (true) {
    // Default language on Thai and Indonesia site is now Thai and Bahasa respectively, therefore only include language param if going to english
    case experience === Experience.Candidate &&
      ['id', 'th'].includes(locale) &&
      (!path || path === '/'):
      return language === 'en' ? '/en' : '';
    case additionalLanguages.includes(language):
      return `/${language}`;
    default:
      return '';
  }
};

export const getLanguageTwoCharsOnly = (language: string): Language => {
  const [langAbbreviation] = language.split('-');
  return langAbbreviation as Language;
};
